import React from 'react';
import buttonImage from '../buttonimage.webp'; // Import button image
import backgroundImage from '../background.webp'; // Import background image
import cardBackgroundImage from '../cardbackground.webp'; // Import card background image

function Rest({ goBack, goHome, handleSaveProgress }) {
    const handleSave = async () => {
        if (typeof handleSaveProgress === 'function') {
            await handleSaveProgress('rest', null, false);
            alert('Session progress has been saved successfully!');
        }
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .rest-nav-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                        width: 100% !important;
                        justify-content: space-between !important;
                        margin: 0 !important;
                        padding: 0 2vw 0 2vw !important;
                    }
                    .rest-nav-row button {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 110px !important;
                        font-size: 15px !important;
                        padding: 10px 0 !important;
                        margin: 0 !important;
                    }
                }
                `}
            </style>
            <div style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}>
                {/* Title */}
                <h3 style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'black',
                    marginBottom: '32px',
                }}>
                    Rest
                </h3>

                {/* Session Helper Cards Row */}
                <div
                    className="rest-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>•  Rest is a cornerstone of wellness, allowing the body and mind to repair, process emotions, and restore energy depleted by stress or trauma.</div>
                            <div>• Embracing rest reduces cortisol levels, calming the nervous system and creating space for subconscious wellness to occur.</div>
                            <div>• Prioritizing rest signals self-worth, countering the cultural bias that constant productivity equals value, which enhances wellness.</div>
                            <div>• Rest facilitates mental clarity, helping uncover insights about personal challenges that are obscured by exhaustion. </div>
                            <div>• Physical rest, like sleep or relaxation, supports the body’s natural wellness mechanisms, strengthening immunity and emotional balance.</div>
                            <div>• Intentional rest, such as mindfulness or leisure, nurtures creativity and intuition, key drivers of wellness and personal growth.</div>
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>1. How many hours of sleep or downtime do you get daily, and do you wake feeling refreshed or still drained?</div>
                            <div>2. What thoughts or emotions arise when you consider taking a break, and what do they reveal about your beliefs around rest?</div>
                            <div>3. When was the last time you allowed yourself to rest without guilt, and how did that impact your mood or energy?</div>
                            <div>4. What activity in your routine feels most restorative, and how often do you make time for it?</div>
                            <div>5. Do you notice any physical or emotional signs, like irritability or fatigue, that might indicate you’re not resting enough?</div>
                            <div>6. If you could design a perfect moment of rest, what would it look like, and what’s stopping you from creating it regularly?</div>
                        </div>
                    </div>
                </div>

                {/* Cards */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '32px', // Add space below the last card (matches margin above top card)
                }}>
                    {/* Card 1 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Rest played a big role for me in my journey.  Before I could rest though, I had to change my beliefs around what it means about me if I rest more often.  I was definitely caught up in the societal expectation that I should do more and rest less in order to be successful.  Instead I found my success in the restful moments when I was willing to be with myself.  When I was not willing to distract myself and when I was willing to be quiet enough to hear my inner self's discomforts and cries, I was able to process through a lot of the backlog of unprocessed trauma from my life prior to that point.  I so appreciate guiltless rest. 
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Learn how to incorporate rest into your daily routine for better health.
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Reflect on how rest can improve your productivity and well-being.
                        </p>
                    </div>
                </div>

                {/* Navigation Buttons */}
                <div
                    className="rest-nav-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '0', // Remove top margin, spacing is now handled by marginBottom on cards container
                        width: '100%',
                    }}>
                    <button style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }} onClick={goBack}>Back</button>
                    <button style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }} onClick={goHome}>Home</button>
                    <button style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }} onClick={handleSave}>Save</button>
                </div>
            </div>
        </>
    );
}

export default Rest;
